export default {  
  walletHistoric: [],
  totalTransactions: [],
  discountCoupons: [],
  couponsCampaign: [],
  cache: {
    walletHistoricLoaded: false,
    totalTransactionsLoaded: false,
    discountCouponsLoaded: false,
    couponsCampaignLoaded: false
  }
}
